// extracted by mini-css-extract-plugin
module.exports = {"shp2-detail-G":"F_shp2-detail-G__2IeOI"};